import * as Yup from "yup";

export const validationSchema = Yup.object({
  is_active: Yup.string().required("Status is required!"),
  title: Yup.string().required("Title is required!"),
  qr_size: Yup.number().required("Qr size is required"),
  qr_x: Yup.number().required("Qr Position X is required!"),
  qr_y: Yup.number().required("Qr Position Y is required!"),
  desk_qr_size: Yup.number().required("Qr size is required"),
  desk_qr_x: Yup.number().required("Qr Position X is required!"),
  desk_qr_y: Yup.number().required("Qr Position Y is required!"),
  image: Yup.string().required("Qr template image is required!"),
});

export const textValidationSchema = Yup.object({
  is_active: Yup.string().required("Status is required!"),
  title: Yup.string().required("Title is required!"),
  qr_size: Yup.number().required("Qr size is required"),
  qr_x: Yup.number().required("Qr Position X is required!"),
  qr_y: Yup.number().required("Qr Position Y is required!"),
  desk_qr_size: Yup.number().required("Qr size is required"),
  desk_qr_x: Yup.number().required("Qr Position X is required!"),
  desk_qr_y: Yup.number().required("Qr Position Y is required!"),
  // text_x: Yup.number().required("Text Position X is required!"),
  // text_y: Yup.number().required("Text Position Y is required!"),
  image: Yup.string().required("Qr template image is required!"),
});
